import {getDefaultIndividualText} from "./individual-text.constant";

export const DEFAULT_CONFIG = {
    admin: {
        ai: {
            customLogo:{
                active: false,
                customLogoFile: null
            },
            wandershareApi: {
                active:false,
                aging_active: false,
                aging_api_key: "",
                aging_api_secret: "",
                aging_age_slider_allowed: false,
                aging_fixed_age: 0,
                aging_priority: 0
            },
            replicate: {
                replicate_remove_bg_active: false,
                replicate_api_key: "",
                replicate_prompting_active: false,
                replicate_prompt_quality: "normal",
                replicate_model: "google/nano-banana-2"
            },
            faceSwap: {
                active: false,
                face_swap_active: false,
                face_swap_api_key: "",
                face_swap_multi_active: false,
                scenesNamesShow: false,
                scenesBtnTitleShow: false,
                sceneBtnTitle: "",
                faceSwapScenes: {
                    enabled: false,
                    enable_animated_bg_files: false,
                    randomizeSceneSelection: false,
                    finalSize: {
                        width: 333,
                        height: 500
                    },
                    internalPictureSize: {
                        width: 333,
                        height: 500
                    },
                    layoutAspectRatio: {
                        width: null,
                        height: null
                    },
                    pictureAspectRatio: {
                        width: null,
                        height: null
                    },
                    internalPicturePosition: {
                        topX: 0,
                        topY: 0
                    },
                    internalPictureRotation: 0,
                    scenesList: [
                    ],
                    scenesNamesShow: false,
                    opacity: 50,
                    scenesBtnTitleShow: false,
                    sceneBtnTitle: ""
                },
                faceSwapOverlays:  {
                    enabled: false,
                    enable_animated_bg_files: false,
                    randomizeSceneSelection: false,
                    finalSize: {
                        width: 333,
                        height: 500
                    },
                    internalPictureSize: {
                        width: 333,
                        height: 500
                    },
                    layoutAspectRatio: {
                        width: null,
                        height: null
                    },
                    pictureAspectRatio: {
                        width: null,
                        height: null
                    },
                    internalPicturePosition: {
                        topX: 0,
                        topY: 0
                    },
                    internalPictureRotation: 0,
                    scenesList: [
                    ],
                    scenesNamesShow: false,
                    opacity: 50,
                    scenesBtnTitleShow: false,
                    sceneBtnTitle: ""
                },
            },
        },
        disablePostFilters: true,
        standbyScreen: false,
        general: {
            screenOrientation: "landscape",
            width: 1920,
            height: 1080,
            aspectRatio: {
                width: 2,
                height: 1
            },
        },
        standbyScreenActivateTime: 30,
        standbyScreenImage: null,
        digitalStartScreenDesign: true,
        printStartScreenDesign: true,
        stripStartScreenDesign: true,
        showQRCode: true,
        individualText: getDefaultIndividualText(),
        offlineQrCode: {
            enabled: false,
            background: null,
            doneButton: {
                width: 6,
                height: 6,
                x: 89,
                y: 92.5,
                customIcon: null
            },
            qrCode: {
                width: 7,
                height: 7,
                x: 50,
                y: 11
            }
        },
        filtersNamesShow: false,
        maxCountOfPrintCopies: 5,
        enableAutoPrint: false,
        autoPrintCopies: 1,
        isAdvanced: false,
        cuttingLine: true,
        upreachBadge: false,
        disableSceneAfterCapture: false,
        photoBooth: {
            enabled: true,
            allowSharing: true,
            allowSharePrintFile: true,
            printWithoutScene: false,
            allowPrinting: true,
            playbackSpeed: 1.5,
            countdownTime: 5,
            showPrinterBleeds: false,
            startScreenDesignSharing: true,
            printingBackgroundMode: "color",
            sharingBackgroundMode: "color",
            printingBackgroundColor: "#ffffff",
            sharingBackgroundColor: "#ffffff",
            showLiveViewOverlays: true,
            shouldOutputPhotoMirrored: true,
            sharingLogos: [{
                width: "95%",
                height: "10%",
                bottom: "2.5%",
                left: "2.5%"
            }],
            sharingLogoAreas: [{
                width: "100%",
                height: "15%",
                bottom: "0",
                left: "0"
            }],
            printingLogos: [{
                width: "75%",
                left: "12.5%",
                bottom: "6%",
                height: "15%"
            }],
            savedData: {
                sharingOverlayFiles: "",
                sharingBackgroundFiles: ""
            },
            sharingFile: {
                finalSize: {
                    width: 500,
                    height: 500
                },
                internalPictureSize: {
                    width: 500,
                    height: 500
                },
                internalPicturePosition: {
                    topX: 0,
                    topY: 0
                },
                internalPictureRotation: 0,
                layoutAspectRatio: {
                    width: null,
                    height: null
                }
            },
            aspectRatio: {
                width: 1,
                height: 1
            },
            //  finalSize 1252×1843 = portrait 2:3, 300dpi, 3mm bleed; extraLargePrintFile removed
            printFile: {
                framesToPrint: 3,
                finalSize: {
                    width: 1252,
                    height: 1843
                },
                internalPhotos: [
                    {
                        size: {
                            width: 1252,
                            height: 1843
                        },
                        pos: {
                            topX: 0,
                            topY: 0
                        },
                        rotation: 0,
                        name: "1"
                    }
                ],
                activePhotoStrip: false
            }
        },
        gifBooth: {
            enabled: true,
            allowSharing: true,
            allowSharePrintFile: true,
            printWithoutScene: false,
            allowPrinting: true,
            countdownTime: 5,
            playbackSpeed: 1.5,
            showPrinterBleeds: false,
            startScreenDesignSharing: true,
            printingBackgroundMode: "color",
            sharingBackgroundMode: "color",
            printingBackgroundColor: "#ffffff",
            sharingBackgroundColor: "#ffffff",
            showLiveViewOverlays: true,
            shouldOutputPhotoMirrored: true,
            sharingLogos: [{
                width: "95%",
                height: "10%",
                bottom: "2.5%",
                left: "2.5%"
            }],
            sharingLogoAreas: [{
                width: "100%",
                height: "15%",
                bottom: "0",
                left: "0"
            }],
            printingLogos: [
                    {
                        bottom: "2.5%",
                        height: "10%",
                        width: "40%",
                        left: "5%"
                    },
                    {
                        bottom: "2.5%",
                        height: "10%",
                        width: "40%",
                        right: "5%"
                    }
                ],
            savedData: {
                sharingOverlayFiles: "",
                sharingBackgroundFiles: ""
            },
            sharingFile: {
                finalSize: {
                    width: 500,
                    height: 500
                },
                internalPicturePosition: {
                    topX: 0,
                    topY: 0
                },
                internalPictureRotation: 0,
                layoutAspectRatio: {
                    width: null,
                    height: null
                },
                internalPictureSize: {
                    width: 500,
                    height: 500
                }
            },
            aspectRatio: {
                width: 1,
                height: 1
            },
            //  finalSize 1252×1843 (portrait 300dpi, 3mm bleed)
            printFile: {
                framesToPrint: 3,
                finalSize: {
                    width: 1252,
                    height: 1843
                },
                internalPhotos: [
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 80,
                            topY: 82
                        },
                        rotation: 0,
                        name: "1a"
                    },
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 80,
                            topY: 577
                        },
                        rotation: 0,
                        name: "2a"
                    },
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 80,
                            topY: 1072
                        },
                        rotation: 0,
                        name: "3a"
                    },
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 680,
                            topY: 82
                        },
                        rotation: 0,
                        name: "1b"
                    },
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 680,
                            topY: 577
                        },
                        rotation: 0,
                        name: "2b"
                    },
                    {
                        size: {
                            width: 480,
                            height: 480
                        },
                        pos: {
                            topX: 680,
                            topY: 1072
                        },
                        rotation: 0,
                        name: "3b"
                    }
                ],
                activePhotoStrip: true
            }
        },
        boomerangBooth: {
            enabled: true,
            allowSharing: true,
            allowPrinting: true,
            allowSharePrintFile: true,
            printWithoutScene: false,
            showPrinterBleeds: false,
            startScreenDesignSharing: true,
            printingBackgroundMode: "color",
            sharingBackgroundMode: "color",
            printingBackgroundColor: "#ffffff",
            sharingBackgroundColor: "#ffffff",
            showLiveViewOverlays: true,
            shouldOutputPhotoMirrored: true,
            sharingLogos: [{
                width: "95%",
                height: "10%",
                bottom: "2.5%",
                left: "2.5%"
            }],
            sharingLogoAreas: [{
                width: "100%",
                height: "15%",
                bottom: "0",
                left: "0"
            }],
            printingLogos: [
                {
                    bottom: "2.5%",
                    height: "10%",
                    width: "40%",
                    left: "5%"
                },
                {
                    bottom: "2.5%",
                    height: "10%",
                    width: "40%",
                    right: "5%"
                }
            ],
            countdownTime: 5,
            playbackSpeed: 1.5,
            captureTime: 1.5,
            aspectRatio: {
                width: 1,
                height: 1
            },
            //  finalSize 1252×1843 (portrait 300dpi, 3mm bleed)
            printFile: {
                framesToPrint: 3,
                finalSize: {
                    width: 1252,
                    height: 1843
                },
                internalPhotos: [
                    {
                        pos: {
                            topX: 80,
                            topY: 82
                        },
                        name: "1a",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    },
                    {
                        pos: {
                            topX: 80,
                            topY: 577
                        },
                        name: "2a",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    },
                    {
                        pos: {
                            topX: 80,
                            topY: 1072
                        },
                        name: "3a",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    },
                    {
                        pos: {
                            topX: 680,
                            topY: 82
                        },
                        name: "1b",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    },
                    {
                        pos: {
                            topX: 680,
                            topY: 577
                        },
                        name: "2b",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    },
                    {
                        pos: {
                            topX: 680,
                            topY: 1072
                        },
                        name: "3b",
                        size: {
                            width: 480,
                            height: 480
                        },
                        rotation: 0
                    }
                ],
                activePhotoStrip: true
            },
            savedData: {
                sharingOverlayFiles: "",
                sharingBackgroundFiles: ""
            },
            sharingFile: {
                finalSize: {
                    width: 500,
                    height: 500
                },
                internalPictureSize: {
                    width: 500,
                    height: 500
                },
                layoutAspectRatio: {
                    width: null,
                    height: null
                },
                internalPicturePosition: {
                    topX: 0,
                    topY: 0
                },
                internalPictureRotation: 0
            }
        },
        videoBooth: {
            enabled: false,
            allowSharing: true,
            shouldOutputPhotoMirrored: true,
            enableChromakey: false,
            enableSoundRecording: false,
            countdownTime: 5,
            playbackSpeed: 1,
            captureTime: 1.5,
            resolutionOptions: "hd",
            sliderValue:300
        },
        startScreenAreas: {
            single: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "20vw"
            },
            gif: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "40vw"
            },
            boomerang: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "60vw"
            },
            video: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "80vw"
            }
        },
        startScreenDefaultIcons: false,
        startScreenReturnTime: 90,
        startScreenPreviewSize: {
          width: 1920,
          height: 1080
        },
        startScreenBackgroundMode: "color",
        startScreenBackgroundColor: "#ffffff",
        startScreenImageStyle: "stretch",
        startScreenLogo: {
          enabled: true,
          file: {},
          position: 2,
          size: 30
        },
        startScreenLiveView: {
          enabled: false,
          backgroundOpacity: 50,
          iconsOpacity: 100
        },
        // removeBg: {
        //     active: true,
        //     apiKey: "",
        //     totalCredit: 123,
        //     availableCredits: 0,
        //     balance: 0,
        //     assigned: 0,
        //     used: 0
        // },
        cameraPresetName: "Default",
        outputSettings: {
            enableEmailSharing: true,
            enableSmsSharing: false,
        },
        scenes: {
            enabled: false,
            randomizeSceneSelection: false,
            finalSize: {
                width: 500,
                height: 500
            },
            internalPictureSize: {
                width: 500,
                height: 500
            },
            layoutAspectRatio: {
                width: null,
                height: null
            },
            pictureAspectRatio: {
                width: null,
                height: null
            },
            internalPicturePosition: {
                topX: 0,
                topY: 0
            },
            internalPictureRotation: 0,
            scenesList: [
            ],
            scenesNamesShow: false,
            opacity: 50,
            scenesBtnTitleShow: false,
            sceneBtnTitle: ""
        },
        liveView: {
            enabled: true,
            forAllScenes: true,
            liveViewMode: "regular",
            liveViewPreviewSize: {
                width: 1920,
                height: 1080
            },
            liveViewBackgroundMode: "color",
            liveViewBackgroundColor: "#ffffff",
            liveViewBackground: "",
            filter: {
                enabled: true,
                liveViewBackgroundMode: "color",
                liveViewBackgroundColor: "#ffffff",
                liveViewBackground: "",
            },
            output: {
                enabled: true,
                liveViewBackgroundMode: "color",
                liveViewBackgroundColor: "#ffffff",
                liveViewBackground: "",
            },
            shouldOutputPhotoMirrored: true,
            hideOutputPictureVideo: false,
            hideSharingOptions: false,
            customButtons: {
                active: false,
                generalUiButtonsSettings:{
                    back: {width: 4.5, height: 4.5, x: 8, y: 7},
                    sharingBackBtn: {width: 3.5, height: 3.5, x: 8, y: 7},
                    capture: {width: 5.5, height: 5.5, x: 92, y: 50},
                    proceed: {width: 5.5, height: 5.5, x: 92, y: 50},
                    email: {width: 5.5, height: 5.5, x: 16.5, y: 88},
                    sms: {width: 3.5, height: 3.5, x: 35, y: 88},
                    print: {width: 3.5, height: 3.5, x: 45, y: 88},
                    done: {width: 6, height: 6, x: 89, y: 92.5},
                    qrCode: {width: 7, height: 7, x: 50, y: 11,text:"Scan me to download",textSize: 12,textColor: "black"},
                    close: {width: 3.5, height: 3.5, x: 5, y: 28},
                    next: {width: 5, height: 5, x: 93, y: 50},
                    closeError: {width: 5, height: 5, x: 93, y: 50},
                },
                captureModeButtonsSettings:{
                    single: {width: 3.5, height: 3.5, x: 8, y: 44},
                    gif: {width: 3.5, height: 3.5, x: 8, y: 49},
                    boomerang: {width: 3.5, height: 3.5, x: 8, y: 55},
                    scene: {scenePopupColor: "#FFF",width: 36, height: 48, x: 50, y: 57},
                    filter: {width: 5, height: 5, x: 8, y: 38},
                }
            },
            customLogo: {
                enabled:true,
                file: null,
                hideDefaultLogo: false,
                background:{
                    enabled: true,
                    mode: "color",
                    color: "white",
                    image: null
                },
                screenText: {
                    enabled:false,
                    title: "Your image is being created",
                    subText: "It may take a few seconds text",
                    color: "black"
                }
            },
        },
        offlineForms: {
            enabled: false,
            formRequired: false,
            isSendFromForm: false,
            when: "afterPhoto",
            isMultipleAnswers: false,
            formInputs: [
                {
                    required: true,
                    active: true,
                    title: "Name"
                },
                {
                    required: false,
                    active: true,
                    title: "E-Mail"
                },
                {
                    required: true,
                    active: true,
                    title: "Phone Number"
                },
            ],
            customInputs: [
                {
                    required: false,
                    active: false,
                    title: "",
                    inputMode: "text",
                    choices: [{text: ""}]
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    inputMode: "text",
                    choices: [{text: ""}]
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    inputMode: "text",
                    choices: [{text: ""}]
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    inputMode: "text",
                    choices: [{text: ""}]
                },   {
                    required: false,
                    active: false,
                    title: "",
                    inputMode: "text",
                    choices: [{text: ""}]
                },
            ],
            formCheckboxes: [
                {
                    required: true,
                    active: true,
                    title: "",
                    description: "",
                    usePdf: false,
                    fileName: "",
                    fileUrl: "",
                    fileId: null,
                    isInfobox: false,
                    typeIsCheckbox: true,
                    infoBoxCustomText: "Press here to review the full statement…"
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    description: "",
                    usePdf: false,
                    fileName: "",
                    fileUrl: "",
                    fileId: null,
                    isInfobox: false,
                    typeIsCheckbox: true,
                    infoBoxCustomText: "Press here to review the full statement…"
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    description: "",
                    usePdf: false,
                    fileName: "",
                    fileUrl: "",
                    fileId: null,
                    isInfobox: false,
                    typeIsCheckbox: true,
                    infoBoxCustomText: "Press here to review the full statement…"
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    description: "",
                    usePdf: false,
                    fileName: "",
                    fileUrl: "",
                    fileId: null,
                    isInfobox: false,
                    typeIsCheckbox: true,
                    infoBoxCustomText: "Press here to review the full statement…"
                },
                {
                    required: false,
                    active: false,
                    title: "",
                    description: "",
                    usePdf: false,
                    fileName: "",
                    fileUrl: "",
                    fileId: null,
                    isInfobox: false,
                    typeIsCheckbox: true,
                    infoBoxCustomText: "Press here to review the full statement…"
                }
            ],
            infoBoxCustomize: false,
            formCheckboxesTypeLikeRadiobutton: false,
            formSignature: {
                required: true,
                active: false,
                title: "Signature"
            },
            backgroundImage: null
        },
        noise: {
            active: false,
            value: 0
        },
        gdpr:{
            showGdpr: false,
            gdprFile: null,
            gdprCustomButtonsEnabled: false,
            gdprAcceptButtonImage: null,
            gdprDeclineButtonImage: null
        }
    },
    client: {
        emailSender: "UpReach Photo System <photos@upreach.com>",
        advancedHtmlInput: false,
        emailText: "",
        emailTextRow: "",
        emailTemplate: "English",
        emailSubject: "Your UpReach photo",
        allowEmailAttachments: true,
        emailDisclaimer: false,
        emailDisclaimerRequire: false,
        emailDisclaimerText: "",
        emailTitle: "Hey, nice snap!",
        emailTextNoHtml: "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.",
        smsText: "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ",
        smsDisclaimer: false,
        smsDisclaimerRequire: false,
        smsDisclaimerText: ""
    },
};



// WEBPACK FOOTER //
// ./sources/constants/defaulf-config.constant.js